import React, { useEffect, useMemo, useState, Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import { checkAuthenticated, load_user, logout } from '../actions/auth';
import GoogleFontLoader from 'react-google-font-loader';
import { useLocation } from 'react-router-dom';

// Lazy-load UI chrome to trim initial bundle on public routes
const Navbar = lazy(() => import('../components/Navbar'));
const Footer = lazy(() => import('./Footer'));
const Overlay = lazy(() => import('../components/Overlay'));
const Toast = lazy(() => import('./toast/Toast'));

const Layout = ({ logout, checkAuthenticated, load_user, user, scale, no, children, list, setList, isActive, setActive, overlayVisible }) => {

	const { pathname } = useLocation();
	const isPublicHome = !scale && (pathname === '/' || pathname === '/home' || pathname === '/home/');
	const [NavBar, setNavBar] = useState(null);
	const [sidebarExpanded, setSidebarExpanded] = useState(true);

	useEffect(() => {
		checkAuthenticated();
		load_user();
	}, [checkAuthenticated, load_user]);

	// Memoize Google fonts config to avoid reinjecting on rerenders
	const googleFonts = useMemo(
		() => [
			{ font: 'Roboto', weights: [400, 700] },
			{ font: 'Material+Icons' },
		],
		[]
	);
	const fontSubsets = useMemo(() => ['latin', 'cyrillic-ext'], []);

	return (
		<React.Fragment>
			{!isPublicHome && <GoogleFontLoader fonts={googleFonts} subsets={fontSubsets} />}
			{/* <PageLoader display={displayOverlay}></PageLoader> */}
			<div className="wrapper">
				<div className={`main ${scale && no ? `erp-with-sidebar ${sidebarExpanded ? '' : 'erp-sidebar-collapsed'}` : ''}`}>
					{
						scale && no ?
							<Suspense fallback={null}>
								<Navbar onSidebarChange={setSidebarExpanded} setNavBar={setNavBar} NavBar={NavBar} isActive={`/${isActive}`} setActive={setActive} list={list} setList={setList} />
							</Suspense>
							: null}
					<main className="content mt-0 px-0" style={isPublicHome ? { padding: 0 } : undefined}>
						{children}
						<Suspense fallback={null}>
							{list && list.length ? (
								<Toast
									toastList={list}
									position="bottom-right"
									autoDelete={true}
									dismissTime={10000}
								/>
							) : null}
							{overlayVisible && <Overlay />}
						</Suspense>
					</main>

					{
						((scale && no) || isPublicHome) ?
							null
							:
							<Suspense fallback={null}>
								<footer className="container-fluid p-0 m-0 w-100">
									<Footer />
								</footer>
							</Suspense>
					}
				</div>
			</div>
		</React.Fragment>
	);
};
const mapStateToProps = (state, props) => ({
	user: state.auth.user,
	scale: state.auth.scale,
	no: state.auth.no,
	overlayVisible: state.auth.OverlayDisplay,
});
export default connect(mapStateToProps, { logout, checkAuthenticated, load_user })(Layout);
